import { ErrorCode } from './errorCode.js';

export class Base {
    constructor() {
        this.redirectUrl = '';
        this.baseUrl = window.location.protocol + "//" +  window.location.host;
        this.errorCode = new ErrorCode();
        this.resetRequest = new Request('POST', '/api/resetpassword');
        this.decryptRequest = new Request('POST', '/api/decrypt');
        this.decryptedCustomerId = {};
        this.baseInit();
    };

    baseInit() {
        document.querySelector('body').addEventListener('keydown', (event) => {
            this.enterSubmit(event);
        });

        this.redirectUrl = CONFIG.redirectUrl;
        if(CONFIG.environment.isLive == false) { console.log("Template: " + CONFIG.initialForm); }

        // Check for __pid cookie, set if not exists
        if(document.cookie.search('__pid') == -1) {
            let pidDomain = location.hostname.replace("login.", ".");
            console.log("__pid cookie not found, setting __pid cookie to domain: " + pidDomain);
            let options = { expires: 365, domain: pidDomain, path: '/', sameSite: 'Lax', secure: this.secureCookie };
            Cookies.set('__pid', pidDomain, options);
        } 
    }

    get registerRoute() {
        return this.baseUrl + "/registrierung" +  window.location.search;
    }

    get missingName() {
        return (CONFIG.registrationReason == "Kommentar" && CONFIG.nameless);
    }

    get missingNameRoute() {
        return this.baseUrl + "/ihr-name-fehlt" +  window.location.search;
    }

    get utpCookie() {
        return Cookies.get('__utp', false);
    }

    get consentCookie() {
        return Cookies.get('_pprv', false);
    }

    get secureCookie() {
        return !CONFIG.environment.isLocal;
    }

    set utpCookie(value) {
        let domain = location.hostname.replace("login.", ".");
        let options = { expires: 365, domain: domain, path: '/', sameSite: 'Lax', secure: this.secureCookie };

        if (value) {
            Cookies.set('__utp', value, options);

            if (!this.consentCookie) {
                Cookies.set('__shnozutp', value, options)
            }
        } else {
            Cookies.remove('__utp', options);
        }
    }

    set tacCookie(value) {
        let domain = location.hostname.replace("login.", ".");
        let options = { expires: 365, domain: domain, path: '/', sameSite: 'Lax', secure: this.secureCookie};

        if (value) {
            Cookies.set('__tac', value, options);
        }
    }

    set nameless(value) {
        CONFIG.nameless = (value.firstName != '' && value.lastName != '') ? false : true;
    }

    enterSubmit(event) {
        // Overriden
    }

    updateTacCookie() {
        let tp = window.tp || [];
        if (tp.api && typeof tp.api.callApi === 'function') {
            tp.push(['setUsePianoIdUserProvider', true]);
            tp.api.callApi('/access/token/list', {}, (data) => {
                if (data.access_token_list) {
                    this.tacCookie = data.access_token_list.value;
                }
                document.location.href = this.redirectUrl;
            });
        } else {
            setTimeout(this.updateTacCookie, 1000);
        }
    }

    hideErrorMessages() {
        let errorMessages = document.querySelectorAll('.form-error');
        if (errorMessages) {
            errorMessages.forEach(errorMessage => {
                errorMessage.classList.add('d-none');
            });
        }
    }
    
    hideAllBlocks() {
        let blockers = document.querySelectorAll('.block');
        if (blockers) {
            blockers.forEach(block => {
                block.classList.add('d-none');
            });
        }
    }
    
    buttonSpinner(targetButton, show = true) {
        let button = (typeof targetButton === 'string') ? document.querySelector(targetButton) : targetButton;
        if(button) {
            button.style.width = button.offsetWidth + "px";
            
            if (show) {
                button.querySelector('span').classList.add('d-none');
                button.querySelector('div.lds-ellipsis').classList.remove('d-none');
            } else {
                button.querySelector('span').classList.remove('d-none');
                button.querySelector('div.lds-ellipsis').classList.add('d-none');
            }
        }
    }

    setStatusbar(percent) {
        let headerDiv = document.querySelector('.title');
        if (headerDiv) {
            headerDiv.classList.remove('verlauf');
            headerDiv.classList.remove('verlauf-50');
            headerDiv.classList.remove('verlauf-75');
            switch(percent) {
                case '25': headerDiv.classList.add('verlauf'); break;
                case '50': headerDiv.classList.add('verlauf-50'); break;
                case '75': headerDiv.classList.add('verlauf-75'); break;
            }
        }
    }

    getUrlParams() {
        const queryString = window.location.search;
        let data = [];
        let urlParams = new URLSearchParams(queryString);
        for (let pair of urlParams.entries()) {
            data[pair[0]] = pair[1];
        }
        return data;
    }

    pushHistoryState(form) {
        let path = '';
        switch (form) {
            case 'login': path = '/'; break
            case 'socialLogin': path = '/social-login'; break
            case 'socialLoginConfirm': path = '/social-login-confirm'; break
            case 'socialLoginConsensConfirm': path = '/social-login-consens-confirm'; break
            case 'googleExternalLink' : path = '/login-mit-google'; break
            case 'appleExternalLink' : path = '/login-mit-apple'; break
            case 'register': path = '/registrierung'; break
            case 'resetPassword': path = '/passwort-vergessen'; break
            case 'logout': path = '/logout'; break
            case 'addPersonalData': path = '/ihr-name-fehlt'; break
            case 'updateAccount': path = '/profil'; break
        }

        let ref = CONFIG.redirectUrl;
        if(CONFIG.environment.isLive == false) { console.log("push history state: ref -> " + ref); }

        let data = {
            ref: ref,
            reason: CONFIG.registrationReason,
        }
        
        // AudioApp native login:
        if(CONFIG.environment.isAudioApp) {
            data.ref = "audioapp-shz://open_app";
        } else {
            // Referer check: Domain is one of our domains, value of ref is not "undefined" or "false"
            
            const url = data.ref; // URL to be tested
            const pattern = /^https:\/\/(?:[^.]+\.)?(rz\.noz|ok\.noz|shz|noz|dk-online|om-online|wilhelmshavener-zeitung)\.(de|works)(?:\/.*)?$/;
            const matches = url.match(pattern);

            if (matches) {
                // URL matches the pattern - keep unchanged
                data.ref = url;
            } else {
                // URL does not match the pattern - create fallback URL
                // Try to extract domain components from the URL
                const urlMatches = url.match(/^https:\/\/(?:www\.)?([^\/]+)/);
                
                if (urlMatches) {
                    const domain = urlMatches[1];
                    // Check if it is one of the expected domains
                    const domainMatches = domain.match(/(rz\.noz|ok\.noz|shz|noz|dk-online|om-online|wilhelmshavener-zeitung)\.(de|works)/);
                    
                    if (domainMatches) {
                        data.ref = `https://www.${domainMatches[1]}.${domainMatches[2]}`;
                    } else {
                        // Fallback if domain is not recognized
                        data.ref = "https://www." + CONFIG.environment.mandant + ".de";
                    }
                } else {
                    // Fallback if URL format is not recognized
                    data.ref = "https://www." + CONFIG.environment.mandant + ".de";
                }
            }
            // console.log("Test Referer nachher: " + data.ref);

        }

        if (CONFIG.descriptionContext && CONFIG.descriptionContext != "default") {
            data.context = CONFIG.descriptionContext
        }

        if (form == "googleExternalLink" && data.reason == "Portal" ) {
            data.socialType = "extendedAccess";
            console.log("push history state: data.socialType set to -> " + data.socialType);
        } else if (form == "appleExternalLink") {
            data.socialType = "apple";
            console.log("push history state: data.socialType set to -> " + data.socialType);
        }


        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        for (let pair of urlParams.entries()) {
            let params = ['uid', 'utm_source', 'utm_medium', 'utm_campaign', 'itm_source', 'itm_medium', 'itm_campaign','gp', 'app', 'socialType', 'up-debug', 'bid', 'watchlistid', 'activation'];
            if (params.includes(pair[0])) {
                data[pair[0]] = pair[1]
            }
        }

        //if (!CONFIG.environment.isNewsApp && !CONFIG.environment.isAudioApp) {
        if (!CONFIG.environment.isNewsApp) {
            let searchParams = new URLSearchParams(data)
            path += '?' + searchParams.toString()
            if(CONFIG.environment.isLive == false) { console.log("push history state: path -> " + path); }
            CONFIG.redirectUrl = data.ref;
            window.history.pushState({form:form}, '', path)
        }
    }

    async redirect() {
        await new Promise(resolve => setTimeout(resolve, 5000));
        console.log('Not activated or other apps customer! Redirect forced');
        document.location.href = this.redirectUrl;
    }

    showBlock(block) {
        let elements = (typeof block === 'string') ? document.querySelectorAll(block) : [block];
        if(elements) {
            elements.forEach(element => {
                element.classList.remove('d-none');
            });
        }
    }

    hideBlock(block) {
        let elements = (typeof block === 'string') ? document.querySelectorAll(block) : [block];
        if(elements) {
            elements.forEach(element => {
                element.classList.add('d-none');
            });
        }
    }

    resetPwConfirm(action) {
        let resetPwConfirmBlock = document.querySelector("#forgotPasswordConfirmation");
        if(action == "show") {
            this.showBlock(resetPwConfirmBlock);
            if(this.emailInput.value != "") {
                resetPwConfirmBlock.querySelector(".forgotPwEmail").innerHTML = this.emailInput.value;
            }
        } else {
            this.hideBlock(resetPwConfirmBlock);
        }
    }

    parseJwt(token) {
        console.log("Parsing JWT Token: ", token);
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (e) {
            return null;
        }
    }

    isInIframe() {
        return window.self !== window.top;
    }

    performRedirect(targeturl) {
       if (! this.isInIframe()) {
            document.location.href = targeturl;
       } else {
            window.parent.postMessage({ loggedIn: true }, '*');
            // Fallback redirect after 5 seconds in case message passing doesn't work
            setTimeout(() => {
                document.location.href = targeturl;
             }, 1000);
       }
    }
    
    validateDecryptedGp(customerId, lastName = "") {
        return new Promise((resolve, reject) => {
            let chkData = { gp: customerId };
            if (lastName) chkData.lastName = lastName;
            let chkRequest = new Request('POST', '/api/validate/gp');
            chkRequest.data = chkData;
            chkRequest.call(resp => {
                if (resp.status == 'ok') {
                    this.decryptedCustomerId.status = "ok";
                    this.decryptedCustomerId.gp = customerId;
                    resolve(this.decryptedCustomerId);
                } else {
                    if (resp.code == 10006) {
                        this.errorCode.login = resp.data.login;
                    }
                    this.decryptedCustomerId.status = "error";
                    this.decryptedCustomerId.gp = customerId;
                    this.decryptedCustomerId.value = resp.code;
                    resolve(this.decryptedCustomerId);
                }
            }, () => {
                this.requestError(this.errorCode.technicalError);
                this.decryptedCustomerId.status = "error";
                this.decryptedCustomerId.gp = customerId;
                this.decryptedCustomerId.value = 10005;
                reject(this.decryptedCustomerId);
            });
        });
    }

    enrichCustomerId(redirect, hideBlock = true) {       
        let gpData = {
            email: this.emailInput.value,
            customerId: this.decryptedCustomerId.gp,
        };
        let req = new Request('POST', '/api/add_cutomerid');
        req.data = gpData;
        req.call(resp => {
            if (resp.status == 'ok') {
                document.location.href = redirect;        
            } else {
                if(document.querySelector('#customerIdBlock')) {
                    console.log("Error enriching GP - Unhiding Blocks...");
                    this.hideBlock("#checkDataBlock");
                    this.showBlock("#customerIdBlock");
                }
                this.buttonSpinner(".check-login-button", false);
                this.errorGp(this.errorCode.getByCode(this.decryptedCustomerId.value));
            }
        }, () => {
            if(document.querySelector('#customerIdBlock')) {
                this.hideBlock("#checkDataBlock");
                this.showBlock("#customerIdBlock");
            }
            this.buttonSpinner(".check-login-button", false);
            this.errorGp(this.errorCode.gpError);
        });
        this.hideBlock('#forgot-password-block');
        if(hideBlock) {
            this.hideBlock('#btnLoginBlock');
        }
    }

    decryptGp() {
        console.log("Encrypted GP found, decrypting.")
        let formData = {
            value:CONFIG.customerId,
        }
        this.decryptRequest.data = formData;
        this.decryptRequest.call(data => {
            if (data.status == 'ok') {
                this.validateDecryptedGp(data.data.value);
            } else {
                this.decryptedCustomerId.status = "error";
                this.decryptedCustomerId.value = 10005;
            }
        }, () => {
            this.requestError(this.errorCode.technicalError);
        });
    }

    resetPwShow() {
        this.buttonSpinner(".check-login-button");
        this.resetPwConfirm("hide");
        this.hideErrorMessages();

        if (this.emailInput.value == "") {
            document.location.href = this.baseUrl + "/passwort-vergessen" +  window.location.search;
        } else {
            let formData = {
                email:this.emailInput.value,
            };
            let errorMessage = "Es ist ein Fehler aufgetreten: <br />";
            this.resetRequest.data = formData;
            this.resetRequest.call(data => {
                this.buttonSpinner(".check-login-button", false);
                if (data.status == 'ok') {
                    forgotPasswordBlock.classList.add("d-none");
                    btnLoginBlock.classList.add("d-none");
                    passwordBlock.innerHTML = "<h1 class=\"main-headline\">Passwort zurücksetzen</h1><div class=\"divider main-headline-divider\"></div><p class=\"email-text main-description-text\">Wir haben Ihnen eine Nachricht an Ihre E-Mail-Adresse gesendet mit einem Link, unter dem Sie Ihr neues Passwort setzen können. Bitte schauen Sie in Ihrem Postfach nach.</p><p class=\"email-text\"><a href=\"" + window.location.protocol + "//" +  window.location.host  +  window.location.search + "\">Zurück zum Login</a></p>";
                } else {
                    errorMessage = errorMessage + response.message;
                    this.requestError(errorMessage);
                }
            }, () => {
                this.buttonSpinner(".check-login-button", false);
                this.requestError(this.errorCode.technicalError);
            });
        }
    }

    findCookieName(spName) {
        let cookiePosition = document.cookie.search(spName);
        let cookiename = document.cookie.substring(cookiePosition, (cookiePosition+16));
        return cookiename;
    }

    togglePwVisibility(id) {
        let toggleIcon = document.getElementById("toggleVisibility");
        let pwInput = document.getElementById(id);
        if (pwInput.type === "password") {
            pwInput.type = "text";
            toggleIcon.classList.add("visible");
        } else {
            pwInput.type = "password";
            toggleIcon.classList.remove("visible");
        }
    }

    checkPasswordStrength(password, button = '.btn.register-button') {
        let strength = 0;
        let asWord = "";
        let tips = "";
        let bars = document.querySelectorAll('.pwstrength.strengthcolor');
        let barWeak = document.querySelector('.pwstrength.strengthcolor.weak');
        let barOk = document.querySelector('.pwstrength.strengthcolor.ok');
        let barGood = document.querySelector('.pwstrength.strengthcolor.good');
        let blockTips = document.querySelector('.pwstrength.tips');
        let regBtn = document.querySelector(button);
        let error = 0;
      
        regBtn.disabled = true;
        // password length (required)
        if (password.length < 6) {
            tips += "<span style='color:#f00'>x Das Passwort muss aus mindestens 6 Zeichen bestehen (derzeit " + password.length + ").</span><br>";
            error = 1;
        } else {
            tips += "<span style='color:#00932D'>&check;</span><span>&nbsp; Das Passwort muss aus mindestens 6 Zeichen bestehen.</span><br>";
            strength += (password.length - 6);
        }
        // numbers (required)
        if (password.match(/\d/)) {
            strength += 1;
            tips += "<span style='color:#00932D'>&check;</span><span>&nbsp; Das Passwort muss mindestens eine Ziffer enthalten.</span><br>";
        } else {
            tips += "<span style='color:#f00'>x Das Passwort muss mindestens eine Ziffer enthalten.</span><br>";
            error = 1;
        }
        // special characters
        let count = (password.match(/[^a-zA-Z\d]/g) || []).length;
        if (count > 0) {
            strength += count;
        }
        // mixed case
        if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
            strength += 1;
        } 
    
        // results
        [].forEach.call(bars, function(bar) {
            bar.classList.add('d-none');
        });
        if ((strength >= 3) && (strength < 7) && (error === 0)) {
            barOk.classList.remove('d-none');
            asWord = '<span style="color:#FFE200;display:inline-block; margin-bottom:6px;font-style: italic;">Medium</span><br>'; 
        } else if ((strength >= 7) && (error === 0)) {
            barGood.classList.remove('d-none');
            asWord = '<span style="color:#4CD94C;display:inline-block; margin-bottom:6px;font-style: italic;">Stark</span><br>';
        } else {
            barWeak.classList.remove('d-none');
            asWord = '<span style="color:#FF3333;display:inline-block; margin-bottom:6px;font-style: italic;">Schwach</span><br>';
            if(CONFIG.environment.isLive == false) { console.log("Error: " + error + " | Stärke: " + strength + " | Count: " + count); }
        }
        blockTips.classList.remove('d-none');
        blockTips.innerHTML = asWord + tips;
        if (error == 0) {
            regBtn.disabled = false;
        }
    }

    requestError(message) {
        let element = document.querySelector('.form-error.form-error-response > p');
        if (element) {
            element.innerHTML = message;
            this.showBlock('.form-error.form-error-response');
        }
    }
}